require('./bootstrap.js');

require('../modernizr-webp.js');
// require('../jasny/jasny-bootstrap.js');
// require('remodal');
// require('../modules/remodal/mobile-fix');
require('../assign-general-functions-to-window.js');
import supportedBrowserNotification from '../core/supported-browser-notification';
const validBrowser = supportedBrowserNotification();
import LiveChatClass from '../live-chat/modules/live-chat-class';
window.liveChatClass = new LiveChatClass;
setTimeout(() => {
    liveChatClass.initLiveChat((typeof liveChatLocationId !== 'undefined') ? liveChatLocationId : false);
}, 500);
import ContactFormValidator from '../validation/ContactFormValidator';
import CustomerLocationHandler from '../modules/CustomerLocationHandler';
import GoogleMapsLoaderClass from '../modules/GoogleMapsLoader';
import LocationDataLoader from '../modules/LocationDataLoader';

// Global function to get the correct map pin icon depending on brand
import getMapIcon from '../modules/mapIcon';

import router from './routes.js';
import store from './store/index.js';

// import getMetaDataFromRoute from './api/GetMetaDataFromRoute';

// import Name from './components/Forms/Name.vue';
// import Title from '../core/components/Forms/Title.vue';
// import FirstName from '../core/components/Forms/FirstName.vue';
// import LastName from '../core/components/Forms/LastName.vue';
// import Email from '../core/components/Forms/Email.vue';
// import Telephone from '../core/components/Forms/Telephone.vue';
// import Dealer from '../core/components/Forms/Dealer.vue';
// import CustomerLocation from '../used-vue/components/Forms/Non-Material/CustomerLocation.vue';
// import Privacy from '../core/components/Forms/Privacy.vue';

import UsedRefineSearchSavedVehicles from '../used-vue/components/UsedRefineSearchSavedVehicles.vue';
const VueScrollTo = require("vue-scrollto");
Vue.use(VueScrollTo);
// import RepresentativeExample from '../used-vue/components/Finance/RepresentativeExample';
// import { getFromStorage } from '../used-vue/api/Storage.js';
import { customEvent, generateLeadEvent, trackPageView } from '../modules/tracking/AnalyticsEvents';
// Campaign:
// import CampaignForm from './components/Campaign/2018/Jan-Sale/Form';
// Vue.component('campaign-form', CampaignForm);

if (validBrowser) {
    window.LocationDataLoader = new LocationDataLoader;
    window.ContactFormValidator = ContactFormValidator;
    window.CustomerLocationHandler = CustomerLocationHandler;
    window.customerLat = getCookieValue('lat');
    window.customerLng = getCookieValue('lng');
    window.customerPostcode = getCookieValue('postcode');
    window.customerGeolocation = getCookieValue('geolocation');
    // Create a global object for getting a new Google Maps instance
    window.GoogleMapsLoader = new GoogleMapsLoaderClass;
    // Handle detecting when Google Maps has finished loading
    window.googleMapsLoaded = () => {
        GoogleMapsLoader.mapLoaded();
    };
    // require('../live-chat/live-chat');
    require('../cookie-warning.js');
    require('../modules/polyfills/string-padStart');

    Vue.mixin({
        methods: {
            gaTag(eventCategory = '', eventAction = '', eventLabel = '') {
                customEvent(eventCategory, eventAction, eventLabel, 0);
            },
            generateLeadEvent(name = 'Misc Event', value = 0, currency = 'GBP') {
                generateLeadEvent(name, currency, value);
            },
            trackPageView() {
                trackPageView();
            }
        }
    });


    // Vue.component('customer-title', Title);
    // Vue.component('customer-first-name', FirstName);
    // Vue.component('customer-last-name', LastName);
    // Vue.component('customer-name', Name);
    // Vue.component('customer-email', Email);
    // Vue.component('customer-location', CustomerLocation);
    // Vue.component('customer-dealer', Dealer);
    // Vue.component('customer-telephone', Telephone);
    // Vue.component('customer-privacy', Privacy);

    // Vue.component('live-chat-button', LiveChatButton);

    // Vue.component('used-car-alert-modal', UsedCarAlertModal);
    // Vue.component('representative-example', RepresentativeExample);

    // const bodyEl = document.body;
    // const metaDescription = document.querySelector('meta[name="description"]');
    const titleEl = document.querySelector('title');
    const canonicalEl = document.querySelector('link[rel="canonical"]');
    let firstLoad = true;

    // if (typeof window.preloadedLocationData !== 'undefined' && typeof window.preloadedLocationData.d !== 'undefined' && window.preloadedLocationData.d.length > 0) {
    //     store.commit('UsedSearchOptions/setUsedDealers', window.preloadedLocationData.d);
    // } else {
    //     console.error('UsedDealer data missing');
    // }

    router.afterEach((to, from) => {
        if (typeof liveChatClass !== 'undefined') {
            liveChatClass.setCustomerType('New');
        }

        canonicalEl.setAttribute('href', 'https://www.stellantisandyou.co.uk' + to.path);

        // Send Page View event
        if (firstLoad) {
            firstLoad = false;
            return;
        }
        if (to.name == 'new-details') {
            return;
        }

        trackPageView(location.pathname, titleEl.innerHTML);
    });

    router.beforeEach((to, from, next) => {
        next();
        return;
        // store.dispatch('Dealers/initializeLocation').then(data => {
        //     // If we go from a dealer landing page which forces the location ID to a single value, to a non dealer landing page, call locationUpdated which will determine the nearest dealers again
        //     if (from.name == 'dealer-landing-page' && to.name !== 'dealer-landing-page') {
        //         store.dispatch('UsedSearchOptions/locationUpdated', false);
        //     }

        //     next();
        // }).catch(error => {
        //     console.error('Dealers/initializeLocation error', error);
        //     next();
        //     return;
        // });
    });

    // Vue.config.devtools = true

    const app = new Vue({
        el: '#app',
        data: {
            brand: 'randd',
        },
        store,
        router,
        components: {
            UsedRefineSearchSavedVehicles,
        },
        created: function () {
            this.$store.dispatch('CustomerData/initialize');
            this.$store.dispatch('Layout/initialize');
            // this.$store.dispatch('FinanceParameters/initialize');
            // this.$store.dispatch('Valuations/initialize');
        },
    });
    window.getMapIcon = getMapIcon;
}